<template>
  <b-list-group-item v-if="dataModal.dataItem.bank_account">
    <div class="font-weight-bold text-primary">
      Banka Hesabı
    </div>
    <div>{{ dataModal.dataItem.bank_account }}</div>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'BankAccount',
  components: {
    BListGroupItem,
  },
  computed: {
    dataModal() {
      return this.$store.getters['accountActivities/transferModal']
    },
  },
}
</script>
